import { z } from 'zod';
import { adapterClient, handleApiError } from './client';
import { canonicalProjectId } from './projectViews';

export const projectBriefSchema = z.object({
  summary: z.string(),
  projectType: z.enum([
    'Other',
    'SmartContract',
    'Frontend',
    'MVP',
    'Audit',
    'MobileApp',
  ]),
  link: z.string().nullable(),
  objectives: z.array(z.string()),
  constraints: z.array(z.string()),
  indicativeBudget: z.object({
    currency: z.literal('USD'),
    range: z.enum([
      'Below10000',
      'From10000To50000',
      'From50000To100000',
      'Above100000',
    ]),
  }),
  delivery: z.discriminatedUnion('preference', [
    z.object({
      preference: z.enum([
        'WithinOneMonth',
        'OneToThreeMonths',
        'ThreeToSixMonths',
      ]),
    }),
    z.object({ preference: z.literal('SpecificDate'), date: z.string() }),
  ]),
});
export type ProjectBrief = z.infer<typeof projectBriefSchema>;
export async function putProjectBrief(
  id: string,
  brief: ProjectBrief,
  signal?: AbortSignal
) {
  try {
    const { data } = await adapterClient.put<unknown>(
      '/projects/' + canonicalProjectId(id) + '/brief',
      { expectedRevision: 0, brief },
      { signal }
    );
    return z
      .object({
        revision: z.number().int().positive(),
        brief: projectBriefSchema,
      })
      .parse(data);
  } catch (error) {
    handleApiError(error, 'save project brief');
  }
}

export async function getProjectBrief(id: string, signal?: AbortSignal) {
  try {
    const { data } = await adapterClient.get<unknown>(
      '/projects/' + canonicalProjectId(id) + '/brief',
      { signal }
    );
    return z
      .object({
        revision: z.number().int().positive(),
        brief: projectBriefSchema,
      })
      .nullable()
      .parse(data);
  } catch (error) {
    handleApiError(error, 'load project brief');
  }
}
